/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_ConfirmInputs */

const en_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const fr_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer`)
};

const de_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const it_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creare`)
};

const ru_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создавать`)
};

const es_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const zh_cn2_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创造`)
};

const ja_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成する`)
};

const hi_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाएं`)
};

const pt_pt2_explorer_display_new_folder_confirm = /** @type {(inputs: Explorer_Display_New_Folder_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Explorer_Display_New_Folder_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_confirm = /** @type {((inputs?: Explorer_Display_New_Folder_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_confirm(inputs)
	if (locale === "de") return de_explorer_display_new_folder_confirm(inputs)
	if (locale === "it") return it_explorer_display_new_folder_confirm(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_confirm(inputs)
	if (locale === "es") return es_explorer_display_new_folder_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_confirm(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_confirm(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_confirm(inputs)
	return en_explorer_display_new_folder_confirm(inputs)
});